<template>
<v-layout >
  <v-card style="width: 100%;margin-bottom:10px" >
    <v-container fluid>
      <v-layout row wrap v-if="!esCliente">
        <v-flex xs12 md4 :mb-2="$vuetify.breakpoint.smAndUp" :pr-1="!$vuetify.breakpoint.smAndDown">
          <o-select-todos
            v-model="promocionesSelect"
            :textoTodos="$t('general.misc.todas')"
            :items="promociones"
            :label="$t('general.misc.promociones')"
            item-text="descripcion"
            item-value="codigo"
            class="multipleSelect selectText"
            multiple
          >
            <v-list-tile
              slot="prepend-item"
              ripple
              @click="toggleSelect"
            >
              <v-list-tile-action>
                <v-icon :color="promocionesSelect.length > 0 ? 'primary' : ''">{{ icono }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title :class="promocionesSelect.length > 0 ? 'primary--text' : ''">{{promocionesSelect.length === promociones.length ? $t('general.misc.deseleccionarTodas') : $t('general.misc.seleccionarTodas')}}</v-list-tile-title>
            </v-list-tile>
          </o-select-todos>
        </v-flex>
        <v-flex xs12 sm6 md4 :mb-2="$vuetify.breakpoint.smAndUp" :pr-1="!$vuetify.breakpoint.xsOnly" :px-1="!$vuetify.breakpoint.mdAndDown"
          v-if="esAdministrador || esComercial">
          <o-select-todos
            v-model="checkSelect"
            :textoTodos="$t('general.misc.todas')"
            :items="checks"
            :label="$t('reservas.listas.situacion')"
            item-text="text"
            item-value="value"
            class="multipleSelect selectText"
            multiple
          >
            <v-list-tile
              slot="prepend-item"
              ripple
              @click="toggleChecks"
            >
              <v-list-tile-action>
                <v-icon :color="checkSelect.length > 0 ? 'primary' : ''">{{ iconoChecks }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title :class="checkSelect.length > 0 ? 'primary--text' : ''">{{checkSelect.length === checks.length ? $t('general.misc.deseleccionarTodas') : $t('general.misc.seleccionarTodas')}}</v-list-tile-title>
            </v-list-tile>
          </o-select-todos>
        </v-flex>
        <v-flex xs12 sm6 md4 :mb-2="$vuetify.breakpoint.smAndUp" :pl-1="!$vuetify.breakpoint.xsOnly">
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('general.misc.buscar')"
            :rules="[rules.min(3)]"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md4 :mb-2="$vuetify.breakpoint.smAndUp" :pr-1="!$vuetify.breakpoint.smAndDown">
          <v-select
            :label="$t('reservaSimplificada.filtroReservas')"
            :items="tiposReserva"
            v-model="tipoReserva"
            clearable
          />
        </v-flex>
      </v-layout>
      <v-layout :mt-2="$vuetify.breakpoint.xsOnly && !esCliente" column v-if="tabsIn" style="overflow:hidden;">
        <v-tabs v-model="active" grow color="primary" dark>
          <v-tabs-slider style="height:6px;" color="secondary"/>
          <v-tab
            v-for="tab in tabs"
            :key="tab.tipo"
            ripple
          >
            <span class="title">{{ tab.titulo }}</span>
          </v-tab>
          <v-tab-item
            v-for="tab in tabs"
            :key="tab.tipo"
          >
            <TableReservaListaCliente
              :loading="loading"
              :promocionesSelect="promocionesSelect"
              :tipoReserva="tipoReserva"
              :checkSelect="checkSelect"
              :search="search"
              :searchFields="searchFields"
              :tipo="tab.tipo"
              @cambiado="cambiado = $event"
            />
          </v-tab-item>
        </v-tabs>
      </v-layout>
      <v-layout v-else>
        <TableReservaListaCliente
          :loading="loading"
          :promocionesSelect="promocionesSelect"
          :tipoReserva="tipoReserva"
          :checkSelect="checkSelect"
          :search="search"
          :searchFields="searchFields"
          :tipo="tipo"
          @cambiado="cambiado = $event"
        />
      </v-layout>
    </v-container>
  </v-card>
  <v-footer v-if="esComercial" absolute class="secondary" style="height:20px;min-height:20px;padding-right:8px">
    <v-spacer></v-spacer>
    <span class="caption primary--text">{{$t('reservas.listas.revisionBackEnd')}}{{versionApi}} {{$t('reservas.listas.revisionFrontEnd')}}{{version}}</span>
  </v-footer>
</v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/mixins/rules.js'
import TableReservaListaCliente from './TableReservaListaCliente'

export default {
  props: {
    tabsIn: {
      type: Boolean,
      default: false
    },
    tipo: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    rulesMixin
  ],
  components: {
    TableReservaListaCliente
  },
  data () {
    return {
      search: null,
      promocionesSelect: [],
      tipoReserva: null,
      checkSelect: [],
      cambiado: false,
      tiposReserva: ['Simplificada', 'Extendida'],
      active: null
    }
  },
  created () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      version: 'version',
      versionApi: 'versionApi',
      promociones: 'promociones/getAll'
    }),
    tabs () {
      return [
        {
          id: 0,
          titulo: this.$t('pages.reservas.venta'),
          tipo: 'VENTA'
        },
        {
          id: 1,
          titulo: this.$t('pages.reservas.alquiler'),
          tipo: 'ALQUILER'

        }
      ]
    },
    headers () {
      return [
        {
          text: this.$t('reservas.listas.cliente'),
          value: 'nombre_cliente',
          align: 'left',
          class: 'hidden-md-and-down',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.promocion'),
          value: 'promocion_descripcion',
          align: 'center',
          class: 'hidden-lg-and-down',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.inmueble'),
          value: 'inmueble_descripcionLarga',
          align: this.$vuetify.breakpoint.mdAndDown ? 'left' : 'center',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.importe'),
          value: 'tarifa_importeTotal',
          align: 'right',
          class: 'hidden-sm-and-down',
          sortable: true
        },
        {
          text: this.$t('reservas.listas.fechaAlta'),
          value: 'fechaAlta',
          align: 'center',
          sortable: true,
          class: this.$vuetify.breakpoint.xsOnly ? 'px-0' : '',
          searchValue: 'fechaAltaFormatted'
        },
        {
          text: this.$t('reservas.listas.estado'),
          value: 'estado',
          align: 'center',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        {
          text: this.$t('reservas.listas.situacion'),
          value: 'situacion',
          align: 'center',
          class: 'hidden-sm-and-down',
          sortable: false
        },
        {
          text: this.$vuetify.breakpoint.smAndDown ? '' : this.$t('reservas.listas.acciones'),
          align: 'right',
          sortable: false
        }
      ]
    },
    searchFields () {
      return this.headers.filter(h => h.sortable).map(h => {
        return h.searchValue ? h.searchValue : h.value
      })
    },
    allChecks () {
      return this.checkSelect.length === this.checks.length
    },
    allSelect () {
      return this.promocionesSelect.length === this.promociones.length
    },
    multipleChecks () {
      return this.checkSelect.length > 0 && !this.allChecks
    },
    multipleSelect () {
      return this.promocionesSelect.length > 0 && !this.allSelect
    },
    icono () {
      if (this.allSelect) return 'mdi-close-box'
      if (this.multipleSelect) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    iconoChecks () {
      if (this.allChecks) return 'mdi-close-box'
      if (this.multipleChecks) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    checks () {
      return [
        {text: this.$t('reservas.listas.enProceso'), value: 'proceso'},
        {text: this.$t('reservas.listas.caducadas'), value: 'caducadas'},
        {text: this.$t('reservas.listas.pendienteRevision'), value: 'pendienteRevision'},
        {text: this.$t('reservas.listas.finalizadas'), value: 'finalizadas'},
        {text: this.$t('reservas.listas.sinSincronizar'), value: 'sinSincronizar'},
        {text: this.$t('reservas.listas.eliminadas'), value: 'eliminadas'},
        {text: this.$t('reservas.listas.anuladas'), value: 'anuladas'}
      ]
    }
  },
  methods: {
    ...mapActions({
      comprobarReservas: 'reservas/comprobarReservas',
      addAlert: 'alerts/add'
    }),
    async initialize () {
      try {
        this.promocionesSelect = this.promociones.map(x => x.codigo)
        this.checkSelect = this.checks.filter(x => x.value !== 'anuladas' && x.value !== 'eliminadas').map(x => x.value)
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    toggleChecks () {
      this.$nextTick(() => {
        if (this.allChecks) {
          this.checkSelect = []
        } else {
          this.checkSelect = this.checks.map(x => x.value)
        }
      })
    },
    toggleSelect () {
      this.$nextTick(() => {
        if (this.allSelect) {
          this.promocionesSelect = []
        } else {
          this.promocionesSelect = this.promociones.map(x => x.codigo)
        }
      })
    }
  },
  watch: {
    cambiado () {
      this.$emit('cambiado', this.cambiado)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reservas/listas/ReservaListaCliente.vue